import { Card as NDSCard } from "@nulogy/components";
import classNames from "classnames";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useSlideOutState from "hooks/state/useSlideOutState";
import Authorization from "policies/Authorization";
import React from "react";
import styled from "styled-components";

const Card = styled(NDSCard)(({ theme }) => ({
  "&:hover": {
    boxShadow: theme.shadows.medium,
  },
  "&.focused": {
    boxShadow: theme.shadows.focus,
  },
  "&.non-draggable:active": {
    cursor: "default",
  },

  "&.non-draggable:hover": {
    cursor: "default",
  },
  backgroundColor: theme.colors.white,
  border: `solid 1px ${theme.colors.grey}`,
  boxShadow: "none",
  padding: "8px",
}));

export default function DraggableWorkOrderCard({ workOrder, children }) {
  const slideOutState = useSlideOutState();
  const applicationContext = useApplicationContext();
  const focused = slideOutState.workOrderId === workOrder.id ? "focus" : null;
  const policy = Authorization.usePolicy();
  const userCanUpdate = policy.canUpdate(Authorization.EntityTypes.WorkOrder);
  const draggability = workOrder.schedulable && userCanUpdate ? "draggable" : "non-draggable";
  const workOrderCodeKebabCase = workOrder.code.replace(/\s/g, "-").toLowerCase();

  if (applicationContext.loading) return null;

  const { settings } = applicationContext;

  return (
    <div
      className={classNames(
        "spec-drag-root",
        draggability,
        `pendo-work-order-card-${workOrderCodeKebabCase}`,
        "pendo-work-order-card",
      )}
      data-drag-application-context={JSON.stringify(applicationContext)}
      data-drag-performance={workOrder.performance}
      data-drag-remaining-duration={workOrder.remainingDuration || ""}
      data-drag-settings={JSON.stringify(settings)}
      data-drag-standard-production-rate={workOrder.standardProductionRate}
      data-drag-unscheduled-quantity={workOrder.unscheduledQuantity}
      data-drag-work-order={JSON.stringify(workOrder)}
      data-testid="work-order-card"
      data-work-order-id={workOrder.id}
    >
      <Card
        className={classNames({
          focused,
          "non-draggable": !workOrder.schedulable || !userCanUpdate,
        })}
      >
        {children}
      </Card>
    </div>
  );
}
